// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store';
import router from './router'
import 'flex.css/dist/data-flex.css';
import moment from 'moment'; // 时间格式转化
import preview from 'vue-photo-preview'; //图片预览
import 'vue-photo-preview/dist/skin.css'; // 图片预览样式
import { numsFormat } from "./utils/common"
import jumpYszLive from './utils/jumpYszLive'; // 医生站免登陆
Vue.prototype.jumpYszLive = jumpYszLive

import app from './utils/bridge';
// 分享，设置标题等通用方法 - app端
Vue.prototype.$app = app;
// dsBridge.call('base.register', '[1,2,3,4,5,6,7]'); // 开启新版本分享
// import  VConsole  from  'vconsole';
// const  vConsole  =  new  VConsole();  // 初始化
// Vue.use(vConsole );

// 4:3  https://imageysz.yxj.org.cn/1586771809327.jpg
// 3:1  https://imageysz.yxj.org.cn/1586772796857.png
// 1:1  https://imageysz.yxj.org.cn/1587453515218.png

Vue.prototype.$moment = moment;
Vue.use(preview);
Vue.prototype.numsFormat = numsFormat
Vue.config.productionTip = false
    // 调试
    // import VConsole from 'vconsole';
    // var vConsole = new VConsole();
    // 调试end
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    render: (h) => h(App),
    router,
    components: { App },
    template: '<App/>',
    store
})


// WEBPACK FOOTER //
// ./src/main.js